/**
 * Event bus local — substitui primevue/utils EventBus (removido no PrimeVue 4).
 */
const callbacks = {};

const EventBus = {
    on(event, callback) {
        if (!callbacks[event]) {
            callbacks[event] = [];
        }
        callbacks[event].push(callback);
    },
    off(event, callback) {
        if (!callbacks[event]) {
            return;
        }
        callbacks[event] = callbacks[event].filter((cb) => cb !== callback);
    },
    emit(event, payload) {
        if (!callbacks[event]) {
            return;
        }
        callbacks[event].forEach((cb) => cb(payload));
    },
};

export default EventBus;
